/* eslint-disable*/
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import styles from '@/Pages/Analytics/ProductAnalysis/AiProductionHistory/AiProductionHistory.module.scss';
import { analyticsAction, formActions } from '@/Actions';
import {
	convertWeightUnit,
	filtersInfoChip,
	formatDate,
	getUnitConvertedQuantity,
	getUnitConvertedUnit,
	useProductData,
	useQuery,
} from '@/Helpers';
import GrnQcLogTable from '@/Components/QcTable/grnQcLogTable';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import { grnQcLogService } from '@/Services/grnQcLog.services';
import { notificationServices } from '@/Services';
import {
	useHistory,
	useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '@/Components/ui/button';
import { Filter, X } from 'lucide-react';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';
import wastageAction from '@/Actions/wastage.action';
import { Chip } from '@mui/material';
import moment from 'moment';

const grnQcLogColMap = {
	'QC ID': 'batchId',
	'Batch Name': 'batchName',
	'PO Id': 'clientPoId',
	'Product Name': 'productName',
	'Qc Date': 'qcDate',
	Category: 'batchId',
	'Sub Category': 'batchId',
	'Sku Code': 'batchId',
	Vendor: 'vendor',
	'Batch Quantity': 'batchId',
	'Mfd.Date': 'manufactureDate',
	Status: 'batchId',
};
const grnQcLogSpecialColumns = [
	{
		title: 'QC ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Batch Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Qc Date',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Batch Quantity',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Mfd.Date',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'Data',
		},
	},
];



const getStatusColor = (status) => {
	switch ((status || '').toUpperCase()) {
		case 'PASS':
			return 'bg-green-100 text-green-700';
			break;
		case 'FAIL':
			return 'bg-red-100 text-red-700';
			break;
		case 'OVERRIDDEN':
			return 'bg-blue-100 text-blue-700';
			break;
		case 'PENDING':
			return 'bg-orange-100 text-orange-700';
			break;
		default:
			return 'bg-gray-100 text-gray-700';
	}
};

const aiMachineQcLogColMap = {
	'UY Id': 'id',
	Store: 'storeName',
	'QC Time': 'QCTime',
	'Order ID': 'OrderId',
	'Product Name': 'ProductName',
	Category: 'id',
	'Sub Category': 'id',
	'Sku Code': 'id',
	'Net Quantity': 'Weight',
	Temp: 'Temp',
};

const aiMachineQcLogSpecialColumns = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'QC Time',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Order ID',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Net Quantity',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Temp',
		config: {
			type: 'Data',
		},
	},
];


const QualityLogs = (props) => {
	const { toggleFiltersDrawer } = props;
	const [exportRef, _] = useState({});
	const [activeTab, setActiveTab] = useState('grnQcLogs');

	const [search, setSearch] = useState({});
	const [filters, setFilters] = useState({});
	const [obj, setObj] = useState(null);
	const location = useLocation();
	const history = useHistory();
	const queryParams = useQuery();
	const orderType = JSON.parse(queryParams.get('orderType'));
	const initialGrnIdPresent = queryParams.get('state')
		? JSON.parse(queryParams.get('state'))?.grnId
		: null;
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const dispatch = useDispatch();
	const qualityList = useSelector((state) => state.wastage.qualityList);
	const aiQualityList = useSelector(
		(state) => state.analytics.QUALITY_ANALYTICS.SEARCH_DATA.list
	);



	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	useEffect(() => {
		const obj = queryParams.get('state')
			? JSON.parse(queryParams.get('state'))
			: null;
		setObj(obj);
	}, []);

	const grnQcLogSpecialColumnsMappings = {
		'QC ID': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'Batch Name': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'PO Id': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'Product Name': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items?.trim() ?? '-'}
				</div>
			);
		},
		Category: (id, items) => {
			const item = qualityList?.find((ele) => {
				return ele?.batchId == items;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products?.find(
						(product) =>
							Number(product?.id) === Number(item?.productId)
					)?.categoryName ?? '-'}
				</div>
			);
		},
		'Sub Category': (id, items) => {
			const item = qualityList?.find((ele) => {
				return ele?.batchId == items;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products?.find(
						(product) =>
							Number(product?.id) === Number(item?.productId)
					)?.subCategoryName ?? '-'}
				</div>
			);
		},
		'Sku Code': (id, items) => {
			const item = qualityList?.find((ele) => {
				return ele?.batchId == items;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products
						?.find(
							(product) =>
								Number(product?.id) === Number(item?.productId)
						)
						?.variants?.find(
							(variant) =>
								Number(variant?.id) === Number(item?.variantId)
						)?.clientVariantId ?? '-'}
				</div>
			);
		},
		'Qc Date': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{formatDate(items) ?? '-'}
				</div>
			);
		},
		Vendor: (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'Batch Quantity': (id, items) => {
			const obj = qualityList?.find?.((item) => item?.batchId == items);
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{convertWeightUnit(
						obj?.batchQuantity,
						obj?.unit,
						undefined,
						true
					) ?? '-'}
				</div>
			);
		},
		'Mfd.Date': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		Status: (_, items) => {
			const obj = qualityList?.find?.((item) => item?.batchId == items);
			const status = obj?.status;
			return (
				<div
					className={`w-[10rem] min-h-[2rem] text-[12px] flex flex-col items-center justify-center rounded-[4px] font-semibold ${getStatusColor(status)}`}
				>
					{status}
					{!obj?.qualityCheckPresent && <span className='text-[10px] text-gray-500'>QC Not Configured</span>}
				</div>
			);
		},
	};

	const aiMachineQcLogSpecialColumnsMappings = {
		'UY Id': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		Store: (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'QC Time': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'Order ID': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		'Product Name': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
		Category: (id, items) => {
			const item = aiQualityList?.find((ele) => {
				return ele?.id == id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products?.find(
						(product) =>
							Number(product?.id) === Number(item?.productId)
					)?.categoryName ?? '-'}
				</div>
			);
		},
		'Sub Category': (id, items) => {
			const item = aiQualityList?.find((ele) => {
				return ele?.id == id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products?.find(
						(product) =>
							Number(product?.id) === Number(item?.productId)
					)?.subCategoryName ?? '-'}
				</div>
			);
		},
		'Sku Code': (id, items) => {
			const item = aiQualityList?.find((ele) => {
				return ele?.id == id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{products
						?.find(
							(product) =>
								Number(product?.id) === Number(item?.productId)
						)
						?.variants?.find(
							(variant) =>
								Number(variant?.id) === Number(item?.variantId)
						)?.clientVariantId ?? '-'}
				</div>
			);
		},
		'Net Quantity': (id, items) => {
			const obj = aiQualityList?.find((ele) => {
				return ele?.id == id;
			});
			const quantity = obj?.unit !== 'count' ? obj?.Weight : obj?.count;
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{convertWeightUnit(quantity, obj?.unit, undefined, true) ??
						'-'}
				</div>
			);
		},
		Temp: (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{items ?? '-'}
				</div>
			);
		},
	};

	const fetchGrnQcLog = async (filtersObj) => {
		const req = {
			data: {
				storeId: filtersObj?.store?.id,
				status: filtersObj?.type,
				...(filtersObj?.grnId ? {} : {dateRangeFilter: {
					from: filtersObj?.dateRange?.from
						? formatDate(filtersObj?.dateRange?.from)
						: formatDate(new Date()),
					to: filtersObj?.dateRange?.to
						? formatDate(filtersObj?.dateRange?.to)
						: formatDate(new Date()),
				}}),
				productId: filtersObj?.product?.id ?? filtersObj?.productId ?? null,
				productCategoryId: filtersObj?.productCategory?.id ?? null,
				vendorId:
					filtersObj?.vendor?.id ?? filtersObj?.vendors?.id ?? null,
				grnId: filtersObj?.grnId ?? null,
				productionQCLogs:
					filtersObj?.productionQCLogs ??
					(activeTab === 'productionQCLogs'),
			},
		};
		try {
			const res = await grnQcLogService.fetchGrnQcLog(req);
			if (res?.statusCode === 200) {
				dispatch(wastageAction.qualityList(res?.data));
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data fetched successfully',
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: res?.message || 'An error occurred',
				});
			}
		} catch (error) {
			console.error('Error fetching GRN QC log:', error);
		}
	};

	useEffect(() => {
		if (!orderType || orderType === 'capex') {
			setActiveTab('grnQcLogs');
			if (obj?.grnId) {
				const filtersObj = {
					...filters,
					productId: obj?.productId ?? null,
					grnId: obj?.grnId ?? null,
				};
				fetchGrnQcLog(filtersObj);
			}
		} else {
			setActiveTab(orderType);
			if (orderType == 'aiMachineQcLogs') {
				fetchAiMachineQcLog(filters);
			} else {
				handleQcFetch(filters, orderType);
			}
		}
	}, [obj]);

	const generateData = () => {
		let data;
		activeTab === 'grnQcLogs' || activeTab === 'productionQCLogs'
			? (data = qualityList)
			: (data = aiQualityList);
		const filteredData = data?.filter((obj) => {
			if (search?.value === 'productName') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			} else if (search?.value === 'clientPoId') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			} else if (search?.value === 'OrderId') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			}
			return true;
		});
		return filteredData;
	};

	const fetchAiMachineQcLog = async (filters) => {
		const req = {
			data: {
				storeId: filters?.store?.id,
				status: filters?.type,
				dateRangeFilter: {
					from: filters?.dateRange?.from
						? formatDate(filters?.dateRange?.from)
						: formatDate(new Date()),
					to: filters?.dateRange?.to
						? formatDate(filters?.dateRange?.to)
						: formatDate(new Date()),
				},
				productId: filters?.product?.id ?? null,
				productCategoryId: filters?.productCategory?.id ?? null,
				vendorId: filters?.vendor?.id ?? null,
				qcType: 'INWARD_QC',
				onlyMachineScans: true,
			},
		};
		try {
			const res = await grnQcLogService.fetchAiSupervisorScans(req);
			if (res?.statusCode === 200) {
				dispatch(analyticsAction.setAiQualityListScan(res?.data));
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data fetched successfully',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		}
	};
	// Add a useEffect to handle date filter changes;

	const handleQcFetch = (thisFilters = filters, tab = activeTab) => {
		const filtersObj = {
			...thisFilters,
			productId: obj?.productId ?? null,
			grnId: obj?.grnId ?? null,
			productionQCLogs: tab === 'productionQCLogs',
		};
		fetchGrnQcLog(filtersObj);
	};

	const handleListFetch = (filters) => {
		setFilters(filters);
		if (activeTab === 'grnQcLogs' || activeTab === 'productionQCLogs') {
			handleQcFetch(filters);
		} else {
			fetchAiMachineQcLog(filters);
		}
	};
	const fetchWithoutFilters = () => {
		const searchParams = new URLSearchParams(window.location.search);
		setObj(null);
		searchParams.delete('state');
		history.push({
			pathname: location.pathname,
			search: searchParams.toString(),
		});
		fetchGrnQcLog(filters);
	};

	const filtersInfo = {
		header: {
			date: false,
			store: false,
			statusAndTypes: false,
			product: false,
		},
		dateRangeOnly: {
			show: true,
		},
		product: {
			show: true,
			singleSelect: true,
		},
		vendor: {
			show: true,
			singleSelect: true,
		},
		productCategory: {
			show: true,
			singleSelect: true,
		},
		store: {
			show: true,
		},
		type: {
			text: 'Select Status',
			show: true,
			list: [
				{
					label: 'Pass',
					type: 'PASS',
				},
				{
					label: 'Fail',
					type: 'FAIL',
				},
				{
					label: 'Pending',
					type: 'PENDING',
				},
				{
					label: 'Approval Pending',
					type: 'APPROVAL PENDING',
				},
				{
					label: 'Overridden',
					type: 'OVERRIDDEN',
				},
			],
		},
	};
	const exportInfo = {
		showExportBtn: true,
	};
	const dropDownItems = [
		{
			label: 'Product Name',
			value:
				activeTab === 'grnQcLogs' || activeTab === 'productionQCLogs'
					? 'productName'
					: 'ProductName',
		},
		{
			label: 'PO Id',
			value: 'clientPoId',
		},
		{
			label: 'Order ID',
			value: 'OrderId',
		},
	];


	return (
		<div className={styles.root}>
			<ImagesFinder
				onSubmit={handleListFetch}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				avoidInitialCall={
					obj?.grnId || initialGrnIdPresent ? true : false
				}
				tabType={activeTab}
			/>
			<p className='text-[16px] font-bold text-start ml-[1rem] mt-[12px]'>
				Quality Logs
			</p>
			<div className='flex flex-col p-2'>
				<div className='flex items-center justify-between w-full'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						placeholderText='Search ...'
					/>
					<Button
						onClick={(e) => {
							toggleFiltersDrawer(true, {
								exportFrontend: true,
								handleExportFrontend: () =>
									exportRef?.current?.(
										`${activeTab}_logs_${moment(filters?.dateRange?.from)?.format('YYYY-MM-DD')}_to_${moment(filters?.dateRange?.to)?.format('YYYY-MM-DD')}.csv`
									),
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			<div className='flex flex-col'>
				<div className='flex items-center justify-between w-full'>
					<Tabs
						value={activeTab}
						onValueChange={(value) => {
							setActiveTab(value);
							const searchParams = new URLSearchParams(location.search);
							searchParams.set('orderType', JSON.stringify(value));
							history.replace({
								search: searchParams.toString(),
							});

							if (
								value === 'grnQcLogs' ||
								value === 'productionQCLogs'
							) {
								handleQcFetch(filters, value);
							} else {
								fetchAiMachineQcLog(filters);
							}
						}}
						defaultValue={activeTab}
						className='p-2 pb-0'
					>
						<TabsList className='h-auto w-auto inline-flex'>
							<TabsTrigger
								value='grnQcLogs'
								className='px-4 data-[state=active]:h-[2.5rem] data-[state=active]:bg-yellow-500 data-[state=active]:text-black data-[state=active]:m-1 data-[state=active]:rounded-md'
							>
								GRN QC Logs
							</TabsTrigger>
							<TabsTrigger
								value='productionQCLogs'
								className='px-4 data-[state=active]:h-[2.5rem] data-[state=active]:bg-yellow-500 data-[state=active]:text-black data-[state=active]:m-1 data-[state=active]:rounded-md'
							>
								Production QC Logs
							</TabsTrigger>
							<TabsTrigger
								value='aiMachineQcLogs'
								className='px-4 data-[state=active]:h-[2.5rem] data-[state=active]:bg-yellow-500 data-[state=active]:text-black data-[state=active]:m-1 data-[state=active]:rounded-md'
							>
								AI Supervisor QC Scans
							</TabsTrigger>
						</TabsList>
					</Tabs>
					{obj?.grnId && (
						<Chip
							icon={
								<X
									className='mr-1 cursor-pointer'
									size={18}
									onClick={() => fetchWithoutFilters()}
								/>
							}
							label={`GRN ID: ${obj?.grnId}`}
							className='bg-slate-100 text-gray-700 hover:bg-slate-200 transition-colors duration-200 shadow-sm border border-gray-200 rounded-full'
						/>
					)}
					{filtersInfoChip(filtersInfo, filters)}
				</div>
				<div className='overflow-auto' style={{ maxHeight: '65vh' }}>
					{(activeTab === 'grnQcLogs' ||
						activeTab === 'productionQCLogs') && (
						<GrnQcLogTable
							data={generateData()}
							exportRef={exportRef}
							colMap={Object.fromEntries(
								Object.entries(grnQcLogColMap).filter(
									([key, value]) => {
										if (activeTab === 'productionQCLogs') {
											return key !== 'Vendor';
										}
										return true;
									}
								)
							)}
							special={grnQcLogSpecialColumns.filter((ele) => {
								if (activeTab === 'productionQCLogs') {
									return ele?.title !== 'Vendor';
								}
								return true;
							})}
							specialMappings={grnQcLogSpecialColumnsMappings}
							tableType={activeTab}
							location={location}
						/>
					)}
					{activeTab === 'aiMachineQcLogs' && (
						<GrnQcLogTable
							data={generateData()}
							exportRef={exportRef}
							colMap={aiMachineQcLogColMap}
							special={aiMachineQcLogSpecialColumns}
							specialMappings={
								aiMachineQcLogSpecialColumnsMappings
							}
							tableType='aiMachineQcLogs'
							location={location}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

QualityLogs.defaultProps = {};

const mapStateToProps = (state) => {
	const stores = state?.form?.STORES?.data?.LIST;
	const { query: searchQuery, searchBy } =
		state.analytics.AI_PRODUCTION_ANALYSIS.SEARCH_DATA;
	return {
		stores,
		searchQuery,
		searchBy,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};
export default connect(mapStateToProps, mapDispatchToProps)(QualityLogs);
